module.exports = __webpack_public_path__ + "static/ossiachersee-insider-stiftsschmiede-ossiach-eee4a5a6490799daaef9fad975154488.jpeg";